import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { LiveForexProvider } from "@/contexts/LiveForexContext";
import Index from "./pages/Index";
import TradingZone from "./pages/TradingZone";
import MarketRoute from "./pages/MarketRoute";
import TradingBots from "./pages/TradingBots";
import AuthConfirmed from "./pages/AuthConfirmed";
import ResetPassword from "./pages/ResetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import NotFound from "./pages/NotFound";
import ZIndexDebugOverlay from "./components/dev/ZIndexDebugOverlay";

const queryClient = new QueryClient();

const FOREX_WS_URL = `wss://${import.meta.env.VITE_SUPABASE_PROJECT_ID}.supabase.co/functions/v1/live-forex`;

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <LiveForexProvider wsUrl={FOREX_WS_URL}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <main>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/market" element={<MarketRoute />} />
                <Route path="/trading-zone" element={<TradingZone />} />
                <Route path="/trading-bots" element={<TradingBots />} />
                <Route path="/auth/confirmed" element={<AuthConfirmed />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
          </BrowserRouter>
          {(() => {
            const enabled = import.meta.env.DEV;
            return enabled ? <ZIndexDebugOverlay /> : null;
          })()}
        </TooltipProvider>
      </LiveForexProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
